import { ChartSeriesTypeConstants } from "./ah.mb.googleChartRenderer";

/**
 * View data record (obsolete, use ChartData)
 */
//export interface IViewDataRecord {
//    /**
//     * The node name
//     */
//    key: string; 
//    values: Array<any>;
//   }

/**
 * Chart series type
 */
//export enum ChartSeriesType {
//    Area = 0,
//    Line = 1,
//    Bar = 2,
//    Combo = 3
//}


/**
* Chart options (different from IChartOptions)
* 
*/
export interface ChartOptions {

    // Todo: merge with IChartOptions
    showLegend: boolean;
    showTitle: boolean;
    showXAxisTitlesFunc: (title: string) => boolean;
    showYAxisTitlesFunc: (title: string) => boolean;
    backgroundColor?: string;
}

/**
 * Chart options
 */
export interface IChartOptions {
    seriesType: number;
    isStacked: boolean;
}

export interface IGeoChartSettings {
    regionCode: string;
    resolution: "countries" | "provinces" | "metros";
}

/**
 * IViewData interface (aka ChartableReportResult)
 */
export interface IViewData {
    title: string;
    //result: Array<IViewDataRecord>;
    yAxisDataType: string;
    xAxisDataType: string;
    dataType: string;
    failText: string;
    chartOptions: IChartOptions;
    chartData: any;
    isRawData: boolean;
    geoChartSettings: IGeoChartSettings;
}

/**
 * Generic view builder
 */
export interface ViewBuilder {
    /**
     * Builds the view
     * @param modelId 
     * @param nodes 
     * @param needDivCallback 
     * @returns {} 
     */
    buildView(modelId: string, nodes: Array<string>): Promise<any>;

    /**
     * Shows the view
     * @param needDivCallback
     */
    showView(needDivCallback: (request: IDivRequest) => Promise<string>): void;
}

/**
 * Div dimnensions
 */
export interface IDivRequest {
    columns: number;
    rows: number;
    viewName: string;
    subjects: Array<string>; // In practice, the node
}

/**
 * Grid layouter
 */
export interface GridLayouter {

    /**
     * Creates an initial layout
     * @param target 
     * @param viewCount 
     * @returns {} 
     */
    createLayout(target: JQuery, viewDefs: Array<ViewDef>);

    /**
     * Gets a div
     * @returns {} 
     */
    getDiv: (request: IDivRequest) => string;
}

/**
 * View type
 */
export enum ViewType {
    Chart,
    Table,
    Diagram,
    None
}

/**
 * View definition
 */
export interface ViewDef {
    name: string;
    viewType: ViewType;
}

/**
 * View list getter
 */
export interface ViewListGetter {

    /**
     * Gets a list of views for a set of nodes
     * @param nodeList 
     * @returns {} 
     */

    (modelId: string, nodes: Array<string>, queryString: string): Promise<Array<ViewDef>>;
}


export interface IRowsColumns {
    rows: number,
    columns: number;
}

/**
 * Mock view list getter for testing
 */
//export function MockViewListGetter(modelId: string, nodeList: Array<string>,callback: (Array<ViewDef>) =
//{
//    var result = new Array<ViewDef>();

//        result.push({ name: "Inputs", viewType: ViewType.Chart });
//        result.push({ name: "Outputs", viewType: ViewType.Chart });
//        return (result);
//})


/**
 * View registry
 */

export class ViewManager {

    viewBuilders: Array<ViewBuilder>;
    private readonly layouter: GridLayouter;
    private readonly viewListGetter: ViewListGetter;
    private readonly viewDataGetter: ViewDataGetter;
    private readonly viewRenderer: ViewRenderer;
    private readonly spreadsheetRenderer: ViewRenderer;
    private readonly viewDimensionsFunc: (viewData: IViewData) => IRowsColumns;
    private readonly layoutUpdatedCallback: Promise<void>;

    /**
     * Ctor
     * @param reportServices
     * @param viewRenderer
     */
    constructor(viewListGetter: ViewListGetter, layouter: GridLayouter, viewDataGetter:
        ViewDataGetter, viewRenderer, spreadsheetRenderer: ViewRenderer,
        viewDimensionsFunc: (viewData: IViewData) => IRowsColumns,
        layoutUpdatedCallback: Promise<void>) {

        this.viewBuilders = new Array<ViewBuilder>();
        this.layouter = layouter;
        this.viewListGetter = viewListGetter;
        this.viewDataGetter = viewDataGetter;
        this.viewRenderer = viewRenderer;
        this.spreadsheetRenderer = spreadsheetRenderer;

        this.viewDimensionsFunc = viewDimensionsFunc;

        this.layoutUpdatedCallback = layoutUpdatedCallback;

    }

    /**
     * Returns selected views
     * @param selectedOnly
     */
    static getViews(target: JQuery, selectedOnly: boolean): Array<string> {

        const viewCheckboxes = selectedOnly ?
            target.find(".viewSelectorCheckBox:checked") :
            target.find(".viewSelectorCheckBox");

        var result = new Array<string>();

        viewCheckboxes.each((n, checkbox) => {
            const viewData = checkbox.getAttribute("data-viewid");
            if (viewData)
                result.push(viewData);
        });

        return result;
    }

    /**
     * Toggle all views selected
     * @param target
     */
    static toggleViewsSelected(target: JQuery) {

        const viewCheckboxes = target.find(".viewSelectorCheckBox");

        if (viewCheckboxes.length > 0) {
            var newSelectedStr = viewCheckboxes[0].getAttribute("checked") || "false";

            viewCheckboxes.each((n, checkbox) => {
                if (newSelectedStr === "false")
                    checkbox.setAttribute("checked", "true");
                else
                    checkbox.removeAttribute("checked");
            });

        }

    }


    /**
    * Renders all views
    * @param needDivCallback
    */
    renderAll(target: JQuery, modelId: string, nodes: Array<string>, queryString: string, viewTypeFilter: string): void {

        // Define what happens when view list is received

        // Get rid of selector checkboxes
        $(".view-selector-checkbox-div").remove();


        const viewDefHandler = (viewDefs: Array<ViewDef>) => {

            // Sort the viewdefs so the charts are first
            // Even though the load is asychronous we want to get the slowest ones first
            viewDefs.sort((a, b) => a.viewType === ViewType.Chart ? 1 : 0);

            // Filter func for choosing a rendere
            var getViewTypeForData = (data: IViewData): ViewType => {

                if ((viewTypeFilter === "chart" || !viewTypeFilter) && data.chartOptions.seriesType !== ChartSeriesTypeConstants.table)
                    return ViewType.Chart;

                if ((viewTypeFilter === "spreadsheet" || !viewTypeFilter) && data.chartOptions.seriesType === ChartSeriesTypeConstants.table)
                    return ViewType.Table;

                return ViewType.None;
            };

            var getRendererFunc = (data: IViewData): ViewRenderer => {
                // Function to choose a view renderer based on the view data

                var viewType = getViewTypeForData(data);
                switch (viewType) {
                    case ViewType.Chart:
                        return this.viewRenderer;
                    case ViewType.Table:
                        return this.spreadsheetRenderer;
                    default:
                        return null;
                }
            };

            // This is for specificying the required cols/rows size of a view
            // Big for chart, small for spreadsheet
            var getRowsColsFunc = (data: IViewData): IRowsColumns => {

                var dimensions = this.viewDimensionsFunc(data);

                var viewType = getViewTypeForData(data);
                switch (viewType) {
                    case ViewType.Chart:
                        return dimensions;
                    //return { columns: dimensions.columns /*4*/, rows: dimensions.rows /*2*/ };
                    case ViewType.Table: return dimensions;
                    //return { columns: 3, rows: 1 };
                    default:
                        return { columns: 0, rows: 0 };;
                }

                //return (data.result.length > 0 ? data.result[0].values.length : 0) > 1
                //    ? { columns: 4, rows: 2 }
                //    : { columns: 2, rows: 1 };
            }

            // Create charts for the views
            viewDefs.forEach(viewDef => {
                this.viewBuilders
                    .push(new GenericViewBuilder(
                        this.viewDataGetter, // Function that gets the view data
                        getRendererFunc,
                        viewDef.name, // Name of the view
                        getRowsColsFunc,
                        this.layoutUpdatedCallback

                    )
                    );
            });

            // Create the layout
            this.layouter.createLayout(target, viewDefs); // this.viewBuilders.length);

            // Build the views
            this.viewBuilders.forEach(renderer => {

                renderer.buildView(modelId, nodes).then(
                builtView => {
                    renderer.showView(divGetter)
                });
            });

            var divGetter = (request: IDivRequest): Promise<string> => {
                var div = this.layouter.getDiv(request);

                // Can be null if zero cols/rows for this view
                if (div) {

                    const subjects = request.subjects.join(';');

                    //    const selectedCheckBox =
                    //        `<div class="checkbox view-selector-checkbox-div" class="viewSelecterCheckBoxDiv">
                    //<label><input type="checkbox" class="viewSelectorCheckBox" value="selected" data-viewid="${request
                    //            .viewName}"> </input>
                    //    <span>${request.viewName}</span>
                    //    </label>
                    //    <button class="btn btn-default btn-xs expandViewButton" data-view-id="${request.viewName}" data-view-subjects="${subjects}" style="background-color: transparent;border-color: transparent" onclick="expandViewButtonClick(this)"><span class="glyphicon glyphicon-fullscreen"</span></button>
                    //</div>`;

                    // Todo: Put this back in
                    //    div.append(selectedCheckBox);


                    //            `<div class="checkbox view-selector-checkbox-div" class="viewSelecterCheckBoxDiv">
                    //<label><input type="checkbox" class="viewSelectorCheckBox" value="selected" data-viewid="${request.viewName}"> </input>
                    //    <span>Sel${request.viewName}</span>
                    //    </label></div>`;

                    //'<div class="checkbox" style="margin-top:0">'
                    //    + '<label style="font-weight:bold; margin-left:10px">'
                    //    + '<input type="checkbox" class="viewSelectorCheckBox" value="selected" data-viewid="' + viewName + '">'
                    //    + viewName
                    //    + "</label>"
                    //    + "</div>";

                    //                      var resolved = $(div); 
                    //                        const childDiv = resolved.find("div"); //(`#nodeview_child`);

                    var child = `${div} > .child-nodeView`;
                    return Promise.resolve(child);

                    //return Promise.resolve(childDiv);

                    //var newDivId = `${div.attr("id")}_chart`;

                    //target.prepend(`<div id="${newDivId}"></div>`);
                    //return $(`#${newDivId}`);
                }
                return Promise.resolve(div);
            };
        };

        // Get the list of views
        this.viewListGetter(modelId, nodes, queryString).then(viewDefHandler);
    }

}

/**
 * Chart data getter
 */
export interface ViewDataGetter {
    (modelId, nodes, viewName): JQueryPromise<any>;
}

/**
 * Chart view builder
 */
export class GenericViewBuilder implements ViewBuilder {

    // State here - should be passed via promises.
    private data: IViewData;
    private nodes: Array<string>;

    // Function for getting a renderer.  Can return a different renderer based on the data that is 
    // received

    private readonly getRendererFunc: (data: IViewData) => ViewRenderer;
    private readonly getDataFunc: ViewDataGetter;
    private readonly viewName: string;
    private readonly getViewDimensionsFunc: (data: IViewData) => IRowsColumns;
    private readonly containerCreatedCallback: Promise<any>;

    /**
     * Ctor
     * @param dataGetter
     * @param renderer
     */
    constructor(dataGetter: ViewDataGetter,
        getRendererFunc: (data: any) => ViewRenderer,
        viewName: string,
        getViewDimensionsFunc: (data: IViewData) => IRowsColumns,
        containerCreatedCallback: Promise<any>
    ) {

        this.getDataFunc = dataGetter;
        this.getRendererFunc = getRendererFunc;
        this.viewName = viewName;
        this.getViewDimensionsFunc = getViewDimensionsFunc;
        this.containerCreatedCallback = containerCreatedCallback;
    }

    /**
     * Builds the view 
     * @param modelId
     * @param nodes
     * @param needDivCallback
     */
    buildView = (modelId: string, nodes: Array<string>): Promise<IViewData> => {
        this.nodes = nodes;

        // Trigger get data which will call the renderer
        return this.getDataFunc(modelId,
            nodes,
            this.viewName)
            .then((viewData: IViewData) => this.data = viewData);
    }


    showView(needDivCallback: (request?: IDivRequest) => Promise<string>): void {
        // Setup renderer
        var renderFunc = (target: JQuery, data: any) => {

            var renderer =
                this.getRendererFunc(data);
            if (renderer) {
                renderer.render(target, data);
            }
            //this.renderer.render(
        };


        // Get desired dimensions - bigger for a chart.
        var viewDims = this.getViewDimensionsFunc(this.data);

        // Get a div for the view.  Pass in the viewname, which might be 
        // used for the id of the div which could be loaded/saved
        var request: IDivRequest = {
            viewName: this.viewName,
            rows: viewDims.rows,
            columns: viewDims.columns,
            subjects: this.nodes
        };


        needDivCallback(request)
            .then(div => {
                this.containerCreatedCallback.then(() => {

                    var target = $(div);
                    renderFunc(target, this.data);
                });

            });
    }
}

/**
 * View renderer interface
 */
export interface ViewRenderer {

    /**
     * Option to force a specific view type, or -1
     * @param chartSeriesTypeId 
     * @returns {} 
     */
    forceViewType(chartSeriesTypeId: number): void;

    /**
     * Render
     * @param target 
     * @param data 
     * @param doneFunc 
     * @returns {} 
     */
    render(target: JQuery, data: IViewData): void;

    /**
     * Refreshes the view
     * @returns {} 
     */
    refresh();
}

/**
 * Chart view renderer
 */



// WEBPACK FOOTER //
// ./ClientApp/scripts/ah.mb.ui.view-builders.ts